// Auto-generated - do not edit manually
import React from "react";
import { FlagIcon } from "../FlagIcon";
import type { FlagIconProps } from "../types";

const svgContent = `<svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"><g id="flag-icon_qa"><g id="flag"><mask id="mask0_1161_20487" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="1" y="3" width="16" height="12"><rect id="mask" x="1" y="3" width="16" height="12" fill="white"/></mask><g mask="url(#mask0_1161_20487)"><g id="contents"><rect id="background" x="1" y="3" width="16" height="12" fill="#B61C49"/><path id="middle" fill-rule="evenodd" clip-rule="evenodd" d="M1 3H4.39999L7 4L4.39999 5L7 6L4.39999 7L7 8L4.39999 9L7 10L4.39999 11L7 12L4.39999 13L7 14L4.39999 15H1V3Z" fill="#F7FCFF"/></g></g></g></g></svg>`;

export const FlagQA: React.FC<FlagIconProps> = (props) => (
  <FlagIcon {...props} svgContent={svgContent} />
);
